import gql from 'graphql-tag';

export const ADD_PAYOUT_PLAN = gql`
  mutation createPartnerPayoutPlan($input: CreatePartnerPayoutPlanInput!) {
    createPartnerPayoutPlan(input: $input) {
      id
      name
      countryId
      default
      bookingCompletedPercent
      bookingPaidPercent
      country {
        id
        name
        currencyCode
      }
    }
  }
`;

export const QUERY_PAYOUT_PLAN_LIST = gql`
  query listPartnerPayoutPlan(
    $pageNumber: PositiveInteger = 1
    $pageSize: PositiveInteger = 10
    $countryCode: NonEmptyString
    $default: Boolean
  ) {
    listPartnerPayoutPlans(
      pageNumber: $pageNumber
      pageSize: $pageSize
      countryCode: $countryCode
      default: $default
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        numPages
      }
      edges {
        node {
          id
          name
          default
          countryId
          affectedLandlordCommission {
            bookingPaid
            bookingCompleted
          }
          bookingCompletedPercent
          bookingPaidPercent
          country {
            id
            name
            currencyCode
          }
          updatedAt
          updatedByCmsUser {
            firstName
            lastName
          }
        }
      }
    }
  }
`;

export const QUERY_PAYOUT_PLAN_ITEM = gql`
  query getPartnerPayoutPlan($id: ID!) {
    getPartnerPayoutPlan(id: $id) {
      id
      name
      default
      countryId
      bookingCompletedPercent
      bookingPaidPercent
      country {
        id
        name
        currencyCode
      }
    }
  }
`;

export const UPDATE_PAYOUT_PLAN = gql`
  mutation updatePartnerPayoutPlan($input: UpdatePartnerPayoutPlanInput!) {
    updatePartnerPayoutPlan(input: $input) {
      id
      name
      countryId
      default
      bookingCompletedPercent
      bookingPaidPercent
      country {
        id
        name
        currencyCode
      }
    }
  }
`;
